import Grid from "@mui/material/Grid"
import {paletteColors} from "@indebted/theme"
import {MastercardLogo, VisaLogo} from "@indebted/assets"
import {Button} from "@mui/material"
import {useNavigate} from "react-router-dom"

import {ManagePageI18n} from "../types"
import {nextPage} from "../Navigator"

import {
	CardContentLessPadding,
	CardHeaderLessPadding,
	CardHeadingTypography,
	ColoredTypography,
	GreyStyledCard,
	GridWithBottomMargin,
	PaddedDivider,
	StyledDiv,
} from "./styles"

const PaymentArrangementDetailsCard = ({
	PaymentArrangementID,
	I18n,
	InstalmentAmount,
	Frequency,
	EndDate,
	TotalPaymentAmount,
	PaymentMethod,
	PaymentMethodDetails,
	NextDueDate,
}: {
	PaymentArrangementID: string
	I18n: ManagePageI18n
	InstalmentAmount: number
	Frequency: string
	EndDate: string
	TotalPaymentAmount: number
	PaymentMethod: string
	PaymentMethodDetails?: Record<string, string>
	NextDueDate: string
}) => {
	const navigate = useNavigate()

	const onUpdatePlanClick = () => {
		// TODO handle frontend validation
		// if (InstalmentDue.InProgress) {
		// 	InstalmentInProgressModal.Open()
		// 	return
		// }
		navigate(nextPage("update", PaymentArrangementID))
	}

	return (
		<GreyStyledCard variant="outlined">
			<CardHeaderLessPadding
				title={
					<Grid container direction="row" justifyContent="space-between">
						<CardHeadingTypography color={paletteColors.stratos}>
							{I18n.PaymentArrangementDetailsHeading}
						</CardHeadingTypography>
						<Button variant="outlined" onClick={onUpdatePlanClick}>
							{I18n.UpdatePaymentArrangementButtonLabel}
						</Button>
					</Grid>
				}
			/>
			<CardContentLessPadding>
				<Grid container direction="row" justifyContent="space-between">
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{I18n.PaymentArrangementLabel}
						</ColoredTypography>
					</StyledDiv>
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{InstalmentAmount} {Frequency}
						</ColoredTypography>
					</StyledDiv>
				</Grid>
				<PaddedDivider />
				<Grid container direction="row" justifyContent="space-between">
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{I18n.NextInstalmentDueDateLabel}
						</ColoredTypography>
					</StyledDiv>
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{NextDueDate}
						</ColoredTypography>
					</StyledDiv>
				</Grid>
				<PaddedDivider />
				<Grid container direction="row" justifyContent="space-between">
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{I18n.EndDateLabel}
						</ColoredTypography>
					</StyledDiv>
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{EndDate}
						</ColoredTypography>
					</StyledDiv>
				</Grid>
				<PaddedDivider />
				<Grid container direction="row" justifyContent="space-between">
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{I18n.PaymentMethodLabel}
						</ColoredTypography>
					</StyledDiv>
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{PaymentMethod}
						</ColoredTypography>
					</StyledDiv>
				</Grid>
				{PaymentMethodDetails && PaymentMethodDetails.Last4 && (
					<>
						<PaddedDivider />
						<GridWithBottomMargin container direction="row" justifyContent="space-between">
							<StyledDiv>
								<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
									{I18n.PaymentMethodDetailsLabel}
								</ColoredTypography>
							</StyledDiv>
							<StyledDiv>
								{PaymentMethodDetails.CardBrand === "visa" && <VisaLogo />}
								{PaymentMethodDetails.CardBrand === "mastercard" && <MastercardLogo />}
								<ColoredTypography
									style={{marginLeft: 15}}
									variant="body2"
									color={paletteColors.stratosLight2}
								>
									•••• {PaymentMethodDetails.Last4}
								</ColoredTypography>
							</StyledDiv>
						</GridWithBottomMargin>
					</>
				)}
				<PaddedDivider />
				<Grid container direction="row" justifyContent="space-between">
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{I18n.TotalPaymentAmountLabel}
						</ColoredTypography>
					</StyledDiv>
					<StyledDiv>
						<ColoredTypography variant="body2" color={paletteColors.stratosLight2}>
							{TotalPaymentAmount}
						</ColoredTypography>
					</StyledDiv>
				</Grid>
				<PaddedDivider />
			</CardContentLessPadding>
		</GreyStyledCard>
	)
}

export {PaymentArrangementDetailsCard}
